<template>
  <div>
    <div class="banner-bg">
      <img :src="bannerList[0]" v-if="bannerList.length == 1" />
      <el-carousel height="100%" :pause-on-hover="false" :interval="10000" v-if="bannerList.length != 1" arrow="always">
        <el-carousel-item v-for="url in bannerList" :key="url">
          <img :src="url" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="home">
      <div class="home-content">
        <div class="szcp title-font-style-m">数智产品</div>
        <div class="home-list-box">
          <div class="first-level-title">
            <div v-for="(item, id) in productTypes" :class="activeType == id ? 'active' : ''" :key="id"
              @click="selectType(id)">
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="secondary-title">
          <div v-if="productTypes[activeType]?.value">
            <span :class="activeProduct == item.id ? 'active' : ''"
              v-for="(item, index) in productTypes[activeType].value" :key="index" @click="selectProduct(item.id)">{{
                item.brandName
              }}</span>
          </div>
        </div>
        <div class="product-child-box" v-if="showProducts.length">
          <div v-for="(e, i) in showProducts" :key="i"
            @click="toOtherPath(`/product_detail?id=${e.id}&pathName=数智产品,${e.productTypeName},${e.productBrandName},${e.productName}`, 1, ['数智产品', e.productTypeName, e.productBrandName, e.productName])">
            <div class="product-img">
              <img :src="e.picList[0]" />
            </div>
            <div class="product-text">
              <div class="product-title">{{ e.productName }}</div>
              <div>{{ e.productIntroduction }}</div>
            </div>
          </div>
          <div class="more-box">
            <div @click="toOtherPath('/product_service?pathName=产品服务,数智产品', 1, ['产品服务', '数智产品'])">
              <span>更多产品</span>
              <img src="/images/right-red-fine.png" />
            </div>
          </div>
        </div>
        <div class="qdfg">
          <div class="title-font-style-m">渠道覆盖</div>
          <div class="level2-title">携手数智领域头部品牌 抢滩销量新通路</div>
          <img :src="loadUrl.qdfg" />
        </div>
        <div class="jjfa">
          <div class="title-font-style-m">解决方案</div>
          <div class="jjfa-detail"
            :style="{ background: `url(${solutions[activeSolutionsIndex].url})`, backgroundSize: '100% 100%' }"
            @click.stop="changeRouter">
            <div class="jjfa-list-box" @click.stop="null">
              <div v-for="(item, index) in solutions" :key="index"
                :class="activeSolutionsIndex == index ? 'active-j' : ''" @click="activeSolutionsIndex = index">
                <div class="red-line" v-if="activeSolutionsIndex == index"></div>
                <div>{{ item.name }}</div>
                <div class="jjfa-list-text" v-if="activeSolutionsIndex == index">{{ item.content }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="cgal">
          <div class="title-font-style-m">成功案例</div>
          <div class="cgal-window" @mouseenter.stop="stopMove = true" @mouseleave.stop="stopMove = false">
            <div class="cgal-img-list" @mouseenter.stop="null" @mouseleave.stop="null">
              <div class="box1"
                @click="router.push('/case_detail?htmlId=24&pathName=解决方案,应用案例,案例详情'); store.state.pageTitle = ['解决方案', '应用案例', '案例详情']">
                <img :src="loadUrl.cgal_img1" />
              </div>
              <div class="box2">
                <div
                  @click="router.push('/case_detail?htmlId=21&pathName=解决方案,应用案例,案例详情'); store.state.pageTitle = ['解决方案', '应用案例', '案例详情']">
                  <img :src="loadUrl.cgal_img2" />
                </div>
                <div
                  @click="router.push('/case_detail?htmlId=22&pathName=解决方案,应用案例,案例详情'); store.state.pageTitle = ['解决方案', '应用案例', '案例详情']">
                  <img :src="loadUrl.cgal_img3" />
                </div>
              </div>
              <div class="box3"
                @click="router.push('/case_detail?htmlId=14&pathName=解决方案,应用案例,案例详情'); store.state.pageTitle = ['解决方案', '应用案例', '案例详情']">
                <img :src="loadUrl.cgal_img4" />
              </div>
              <div class="box4">
                <div
                  @click="router.push('/case_detail?htmlId=18&pathName=解决方案,应用案例,案例详情'); store.state.pageTitle = ['解决方案', '应用案例', '案例详情']">
                  <img :src="loadUrl.cgal_img5" />
                </div>
                <div
                  @click="router.push('/case_detail?htmlId=20&pathName=解决方案,应用案例,案例详情'); store.state.pageTitle = ['解决方案', '应用案例', '案例详情']">
                  <img :src="loadUrl.cgal_img6" />
                </div>
              </div>
              <div class="box5"
                @click="router.push('/case_detail?htmlId=26&pathName=解决方案,应用案例,案例详情'); store.state.pageTitle = ['解决方案', '应用案例', '案例详情']">
                <img :src="loadUrl.cgal_img7" />
              </div>
              <div class="box6">
                <div
                  @click="router.push('/case_detail?htmlId=31&pathName=解决方案,应用案例,案例详情'); store.state.pageTitle = ['解决方案', '应用案例', '案例详情']">
                  <img :src="loadUrl.cgal_img8" />
                </div>
                <div
                  @click="router.push('/case_detail?htmlId=25&pathName=解决方案,应用案例,案例详情'); store.state.pageTitle = ['解决方案', '应用案例', '案例详情']">
                  <img :src="loadUrl.cgal_img9" />
                </div>
              </div>
              <div class="box1"
                @click="router.push('/case_detail?htmlId=24&pathName=解决方案,应用案例,案例详情'); store.state.pageTitle = ['解决方案', '应用案例', '案例详情']">
                <img :src="loadUrl.cgal_img1" />
              </div>
              <div class="box2">
                <div
                  @click="router.push('/case_detail?htmlId=21&pathName=解决方案,应用案例,案例详情'); store.state.pageTitle = ['解决方案', '应用案例', '案例详情']">
                  <img :src="loadUrl.cgal_img2" />
                </div>
                <div
                  @click="router.push('/case_detail?htmlId=22&pathName=解决方案,应用案例,案例详情'); store.state.pageTitle = ['解决方案', '应用案例', '案例详情']">
                  <img :src="loadUrl.cgal_img3" />
                </div>
              </div>
              <div class="box3"
                @click="router.push('/case_detail?htmlId=14&pathName=解决方案,应用案例,案例详情'); store.state.pageTitle = ['解决方案', '应用案例', '案例详情']">
                <img :src="loadUrl.cgal_img4" />
              </div>
              <div class="box4">
                <div
                  @click="router.push('/case_detail?htmlId=18&pathName=解决方案,应用案例,案例详情'); store.state.pageTitle = ['解决方案', '应用案例', '案例详情']">
                  <img :src="loadUrl.cgal_img5" />
                </div>
                <div
                  @click="router.push('/case_detail?htmlId=20&pathName=解决方案,应用案例,案例详情'); store.state.pageTitle = ['解决方案', '应用案例', '案例详情']">
                  <img :src="loadUrl.cgal_img6" />
                </div>
              </div>
              <div class="box5"
                @click="router.push('/case_detail?htmlId=26&pathName=解决方案,应用案例,案例详情'); store.state.pageTitle = ['解决方案', '应用案例', '案例详情']">
                <img :src="loadUrl.cgal_img7" />
              </div>
            </div>
          </div>
        </div>
        <div class="kfhz">
          <div class="title-font-style-m">开放合作</div>
          <div class="open-cooperation-box">
            <open-cooperation></open-cooperation>
          </div>
        </div>
        <div class="xwzx">
          <div class="title-font-style-m">新闻中心</div>
          <div class="more-box">
            <div>
              <span @click="toOtherPath(`/about_us?pathName=关于我们,新闻动态`, 5, ['关于我们', '新闻动态'])">更多新闻</span>
              <img src="/images/right-red-fine.png" />
            </div>
          </div>
          <div class="xwzx-box">
            <div class="news-content">
              <img v-if="newsList[activeNewsIndex]" :src="newsList[activeNewsIndex].ossPath || ''" />
              <div v-for="(e, i) in newsList" :key="i" :class="activeNewsIndex == i ? 'active' : ''"
                @click="toOtherPath(`/news_detail?id=${e.id}&pathName=关于我们,新闻动态,新闻详情`, 5, ['关于我们', '新闻动态', '新闻详情'])">
                <div>{{ e.title }}</div>
                <div>{{ e.createTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue'
import { getProductTypes, addConsult, getProducts, selectCommonElement, getProductProfile, getProductList } from '@/api'
import OpenCooperation from '@/components/mobile/OpenCooperation.vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'
const loadUrl: any = ref({})

const bannerList = ref([])
const router = useRouter()
const store = useStore()
const newsList: any = ref([])
const showProducts: any = ref([])
const stopMove = ref(false)
const productTypes: any = ref({})
// const activeProductIndex = ref(0)
const activeSolutionsIndex = ref(0)
const activeType = ref(1)
const activeProduct = ref(0)
let time = 0;
let timer: any = null;
const activeNewsIndex = ref(0) //高亮新闻的索引

// 解决方案枚举
const solutions: any = ref(
  [
    {
      name: "文娱",
      content:
        "全景景区导览、虚拟博物馆、虚实融合AR项目应用、商场儿童游乐项目体验、企业展厅、营销展示、虚拟数字人、虚拟直播",
    },
    {
      name: "工业",
      content:
        "设计评审、虚拟装配、维修维护、远程协助、技能培训、数字孪生、点巡检、工厂漫游",
    },
    {
      name: "教育",
      content:
        "基础教育/高等教育/职业教育教学、播控、创新实验室建设、创新课堂建设、企业培训",
    },
    {
      name: "医疗",
      content: "医疗培训、康复治疗、医学科普",
    },
    {
      name: "军警部队",
      content: "虚拟战场演习、武器装备操作训练、灾情救援仿真模拟",
    },
  ]
);

// const activeProductList = (id: number) => {
//   activeProductIndex.value = id
//   getProductsData(id)
// }

const toTop = () => {
  window.scrollTo(0, 0)
}

const toOtherPath = (url: string, titleIndex: number, pageTitle: any) => {
  router.push(url);
  store.state.titleIndex = titleIndex;
  store.state.pageTitle = [...pageTitle]
}

const selectType = (id: number) => {
  activeType.value = id;
  activeProduct.value = 0
  getProductsData(id)
}

const selectProduct = (id: number) => {
  activeProduct.value = id
  getProductsData(activeType.value, id)
}

const changeRouter = () => {
  const solutions = ['文娱解决方案', '工业解决方案', '教育解决方案', '医疗解决方案', '军警部队解决方案']
  router.push(`/solution?type=${activeSolutionsIndex.value}&pathName=解决方案,${solutions[activeSolutionsIndex.value]}`)
  store.state.programmeIndex = activeSolutionsIndex.value
  toTop()
}

onMounted(async () => {
  getProductTypes().then((res: any) => {
    getProductProfile().then((res2: any) => {
      // activeProduct.value = res2[0].brandProfileList[0].id
      res2.forEach((ele: any) => {
        if (!productTypes.value[ele.productTypeId]) {
          productTypes.value[ele.productTypeId] = { name: res[ele.productTypeId], value: [...(ele.brandProfileList || [])] }
        } else {
          productTypes.value[ele.productTypeId].push({ name: res[ele.productTypeId], value: [...(ele.brandProfileList || [])] })
        }
      });
      getProductsData(activeType.value, activeProduct.value)
    })
  })
  selectCommonElement({ columnId: 5 }).then((res: any) => {
    newsList.value = [...res].sort((a: any, b: any) => (a.sortNum ?? 0) - (b.sortNum ?? 0)).slice(0, 4).map((e: any) => {
      const date = new Date(e.createTime)
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();
      const h = date.getHours();
      const mx = date.getMinutes();
      const s = date.getSeconds();
      e.createTime = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
      return e;
    })
  })

  selectCommonElement({ columnId: 1 }).then((res: any) => {
    bannerList.value = [...res].sort((a: any, b: any) => (a.sortNum ?? 0) - (b.sortNum ?? 0)).map((e: any) => e.ossPath)
  })

  function animate() {
    if (!document.querySelector('.cgal-img-list')) return;
    if (!stopMove.value) {
      const oldLeft = (document.querySelector('.cgal-img-list') as any)?.getBoundingClientRect().left;
      if (time == 0) {
        (document.querySelector('.cgal-img-list') as any).style.left = (oldLeft - 0.3) + 'px';
      } else {
        if (oldLeft <= -(window.innerWidth / 750) * 2766) {
          (document.querySelector('.cgal-img-list') as any).style.left = '0px'
        } else {
          (document.querySelector('.cgal-img-list') as any).style.left = (oldLeft - 0.3 * ((new Date().getTime() - time) / 10)) + 'px';
        }
      }
    }
    // 使用requestAnimationFrame循环动画
    time = new Date().getTime()
    requestAnimationFrame(animate);
  }
  requestAnimationFrame(animate);
  if (store.state.userAgent == 'mobile') {
    (document.querySelector('.cgal-window') as any).style.overflow = 'hidden'
  }

  const qdfg: any = await asynchronousRetrieval('nfznxr-images/qdfg.png');
  const cgal_img1: any = await asynchronousRetrieval('nfznxr-images/cgal/img1.png');
  const cgal_img2: any = await asynchronousRetrieval('nfznxr-images/cgal/img2.png');
  const cgal_img3: any = await asynchronousRetrieval('nfznxr-images/cgal/img3.png');
  const cgal_img4: any = await asynchronousRetrieval('nfznxr-images/cgal/img4.png');
  const cgal_img5: any = await asynchronousRetrieval('nfznxr-images/cgal/img5.png');
  const cgal_img6: any = await asynchronousRetrieval('nfznxr-images/cgal/img6.png');
  const cgal_img7: any = await asynchronousRetrieval('nfznxr-images/cgal/img7.png');
  const cgal_img8: any = await asynchronousRetrieval('nfznxr-images/cgal/img8.png');
  const cgal_img9: any = await asynchronousRetrieval('nfznxr-images/cgal/img9.png');
  const jjfa_img1: any = await asynchronousRetrieval('nfznxr-images/jjfa/img1.png');
  const jjfa_img2: any = await asynchronousRetrieval('nfznxr-images/jjfa/img2.png');
  const jjfa_img3: any = await asynchronousRetrieval('nfznxr-images/jjfa/img3.png');
  const jjfa_img4: any = await asynchronousRetrieval('nfznxr-images/jjfa/img4.png');
  const jjfa_img5: any = await asynchronousRetrieval('nfznxr-images/jjfa/img5.png');
  loadUrl.value = { qdfg, cgal_img1, cgal_img2, cgal_img3, cgal_img4, cgal_img5, cgal_img6, cgal_img7, cgal_img8, cgal_img9, jjfa_img1, jjfa_img2, jjfa_img3, jjfa_img4, jjfa_img5 }

  solutions.value[0].url = jjfa_img1
  solutions.value[1].url = jjfa_img2
  solutions.value[2].url = jjfa_img3
  solutions.value[3].url = jjfa_img4
  solutions.value[4].url = jjfa_img5


  timer = setInterval(() => {
    activeNewsIndex.value += 1;
    if (activeNewsIndex.value == newsList.value.length) {
      activeNewsIndex.value = 0;
    }
  }, 3000)
})
const getProductsData = (productTypeId?: number | string, brandId?: number | string) => {
  getProducts({ productTypeId, brandId }).then((res: any) => {
    showProducts.value = res.records.slice(0, 4)
  })
}

</script>
<style scoped lang="less">
.banner-bg {
  width: 100vw;
  height: 348rem;
  background-size: 100% 100%;
  margin-top: 72rem;

  &>div {
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.banner-bg>img {
  width: 100%;
  height: 100%;
}

.home {
  width: 100%;
  text-align: center;
  overflow: hidden;

  .home-content {
    width: 100%;
    display: inline-block;
    padding-top: 40rem;
    background-color: #F7F7F7;

    .change-title {
      height: 60rem;
      background-color: #fff;
      margin: 40rem 0;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 400;
      font-size: 20rem;
      color: #333333;

      &>div {
        height: 60rem;
        line-height: 60rem;
        padding: 0 11rem;
        margin: 0 39rem;
        cursor: pointer;
      }

      .active-p {
        position: relative;
        font-family: PingFangSC-Medium;
        font-weight: 800;
        color: #D81417;

        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 2px;
          background-color: #D81417;
        }
      }
    }

    .qdfg {
      .level2-title {
        font-weight: 400;
        font-size: 28rem;
        color: #999999;
        margin: 16rem 0 32rem;
      }

      img {
        width: 750rem;
        height: 287rem;
      }
    }

    .jjfa {
      padding: 102rem 0 0;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;

      .jjfa-detail {
        position: relative;
        margin-top: 24rem;
        width: 680rem;
        height: 326rem;
        cursor: pointer;

        .jjfa-list-box {
          width: 160rem;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          background: rgba(0, 0, 0, 0.3);
          border-radius: 8rem 0 0 8rem;
          backdrop-filter: blur(10px);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;
          padding: 30rem 0 30rem 24rem;
          box-sizing: border-box;
          cursor: default;

          &>div {
            height: 42rem;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-weight: 600;
            font-size: 24rem;
            color: rgba(255, 255, 255, 0.5);
            padding-left: 6rem;
            cursor: pointer;

            .red-line {
              width: 6rem;
              height: 42rem;
              background-color: #D71819;
              margin-right: 10rem;
            }

            .jjfa-list-text {
              width: 484rem;
              position: absolute;
              bottom: 12rem;
              left: 184rem;
              font-weight: 400;
              font-size: 20rem;
              color: #FFFFFF;
              text-align: left;
              box-sizing: border-box;
              line-height: 1.5;
            }
          }

          .active-j {
            padding-left: 0;
            color: #fff;
          }
        }

        &::before {
          content: '';
          width: 100%;
          height: 144rem;
          background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
          border-radius: 0 0 8rem 0;
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }

    .cgal {
      background-color: #fff;
      padding-top: 64rem;
      position: relative;
      height: 475rem;

      .cgal-window {
        width: 750rem;
        height: 400rem;
        position: relative;
        position: absolute;
        top: 139rem;

        .cgal-img-list {
          width: 3656rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: absolute;
          left: 80rem;

          .box1 {
            width: 343rem;
            height: 400rem;
            background-position: center center;
            /* 水平居中和垂直居中 */

            &::after {
              content: '虚实互动康复医疗';
              position: absolute;
              left: 21rem;
              top: 21rem;
            }
          }

          .box1,
          .box3,
          .box5 {
            position: relative;
            border-radius: 6rem;
            cursor: pointer;
            font-weight: 600;
            font-size: 20rem;
            color: #FFFFFF;

            &:hover {
              box-shadow: 0 0 12rem 0 rgba(215, 24, 25, 0.4);
              background-size: 128% 128%;
              background-position: center center;
              /* 水平居中和垂直居中 */
            }

            &>img {
              width: 100%;
              height: 100%;
            }
          }

          .box2,
          .box4,
          .box6 {
            width: 301rem;
            height: 400rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            font-weight: 600;
            font-size: 20rem;
            color: #FFFFFF;

            &>div {
              position: relative;
              width: 301rem;
              height: 196rem;
              border-radius: 6rem;
              cursor: pointer;

              &:hover {
                box-shadow: 0 0 12rem 0 rgba(215, 24, 25, 0.4);
                background-size: 128% 128% !important;
                background-position: center center !important;
                /* 水平居中和垂直居中 */
              }

              &>img {
                width: 100%;
                height: 100%;
              }
            }
          }

          .box2 {
            &>div:first-child {
              background-position: center center;
              /* 水平居中和垂直居中 */

              &::after {
                content: '数智财会产教融合实践基地';
                position: absolute;
                left: 21rem;
                top: 21rem;
              }
            }

            &>div:last-child {
              background-position: center center;
              /* 水平居中和垂直居中 */

              &::after {
                content: 'AR技术革新博物馆体验';
                position: absolute;
                left: 21rem;
                top: 21rem;
              }
            }
          }

          .box3 {
            width: 343rem;
            height: 400rem;
            background-position: center center;
            /* 水平居中和垂直居中 */

            &::after {
              content: 'VR航空救援协同演练';
              position: absolute;
              left: 21rem;
              top: 21rem;
            }
          }

          .box4 {
            &>div:first-child {
              background-position: center center;
              /* 水平居中和垂直居中 */

              &::after {
                content: '上市公司元宇宙科技展厅';
                position: absolute;
                left: 21rem;
                top: 21rem;
              }
            }

            &>div:last-child {
              background-position: center center;
              /* 水平居中和垂直居中 */

              &::after {
                content: '上海美罗城商场互动营销';
                position: absolute;
                left: 21rem;
                top: 21rem;
              }
            }
          }

          .box5 {
            width: 343rem;
            height: 400rem;
            background-position: center center;
            /* 水平居中和垂直居中 */

            &::after {
              content: 'AR数字空间展';
              position: absolute;
              left: 21rem;
              top: 21rem;
            }
          }

          .box6 {
            &>div:first-child {
              background-position: center center;
              /* 水平居中和垂直居中 */

              &::after {
                content: '大型工业设备在线实时培训';
                position: absolute;
                left: 21rem;
                top: 21rem;
              }
            }

            &>div:last-child {
              background-position: center center;
              /* 水平居中和垂直居中 */

              &::after {
                content: '虚拟现实重构警察培训';
                position: absolute;
                left: 21rem;
                top: 21rem;
              }
            }
          }
        }
      }
    }

    .kfhz {
      background-color: #fff;
      padding-top: 64rem;

      .open-cooperation-box {
        width: 750rem;
        margin-top: 24rem;
        overflow: hidden;
        overflow-x: auto;
      }
    }

    .xwzx {
      background-color: #fff;
      padding-top: 100rem;
      padding-bottom: 60rem;

      .more-box {
        font-weight: 400;
        font-size: 28rem;
        color: #D81417;
        font-family: PingFangSC-Medium;
        margin-top: 22rem;

        &>div {
          display: inline-block;
          cursor: pointer;
        }

        span {
          vertical-align: middle;
        }

        img {
          width: 6rem;
          height: 11rem;
          vertical-align: middle;
          margin-left: 6rem;
        }

        padding-bottom: 32rem;
      }

      .xwzx-box {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        align-items: flex-start;

        &>div {
          position: relative;
          width: 680rem;
          border-radius: 8rem;
          overflow: hidden;
          cursor: pointer;

          .active::before {
            content: '';
            position: absolute;
            left: 22rem;
            top: 24rem;
            width: 6rem;
            height: 6rem;
            background: #414141;
            border-radius: 50%;
          }

          &>div {
            position: relative;
            width: 100%;
            border-radius: 0 0 8rem 8rem;
            padding: 0 16rem 0 36rem;
            box-sizing: border-box;
            font-size: 22rem;
            color: #414141;
            text-align: left;
            padding-bottom: 24rem;
            border-bottom: 2rem solid #ECECEC;
            margin-bottom: 22rem;

            &>div:first-child {
              font-weight: 600;
              font-size: 28rem;
              color: #414141;
              line-height: 40rem;
              margin-bottom: 8rem;
            }

            &>div:last-child {
              font-size: 20rem;
            }
          }

          &>div:last-child {
            border-bottom: none;
          }
        }

        img {
          width: 100%;
          height: 400rem;
          margin-bottom: 24rem;
          border-radius: 8rem;
        }
      }
    }

    .product-child-box {
      position: relative;
      padding-bottom: 105rem;
      width: 750rem;
      text-align: left;
      padding-left: 16rem;

      &>div {
        width: 352rem;
        height: 536rem;
        background: #fff;
        border-radius: 8rem;
        padding: 10rem 10rem 30rem 10rem;
        box-sizing: border-box;
        display: inline-block;
        cursor: pointer;
        margin-bottom: 14rem;
        vertical-align: middle;

        // &:hover {
        //   box-shadow: 0px 10px 12px 0px rgba(215, 24, 25, 0.2), 0px 0px 4px 0px rgba(215, 24, 25, 0.2);
        // }

        .product-img {
          width: 100%;
          background: #F7F7F7;
          border-radius: 4rem;
          overflow: hidden;
          font-size: 0;

          img {
            width: 100%;
            height: auto;
          }
        }

        .product-text {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 20rem;
          color: #7D7D7D;
          text-align: left;

          .product-title {
            font-weight: bold;
            font-size: 28rem;
            color: #000000;
            text-align: center;
            margin: 18rem 0 6rem;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
          }

          &>div:last-child {
            width: 100%;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1.5;
          }
        }
      }

      &>div:nth-child(2n) {
        margin-left: 14rem;
      }

      .more-box {
        width: 100%;
        height: 25rem;
        line-height: 25rem;
        padding: 0;
        text-align: right;
        font-weight: 400;
        font-size: 28rem;
        color: #D81417;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: transparent;
        cursor: default;
        margin: 10rem 0 0;

        &:hover {
          box-shadow: none;
        }

        &>div {
          cursor: pointer;

          span {
            vertical-align: middle;
          }
        }

        img {
          width: 6rem;
          height: 11rem;
          margin-left: 6rem;
          vertical-align: middle;
          margin-bottom: 2rem;
        }
      }
    }

    .home-list-box {
      width: 750rem;
      overflow: hidden;
      overflow-x: auto;
      background-color: #fff;
      margin-top: 24rem;

      .first-level-title {
        height: 72rem;
        white-space: nowrap;

        &>div {
          position: relative;
          height: 72rem;
          line-height: 72rem;
          font-size: 28rem;
          margin: 0 32rem;
          cursor: pointer;
          font-weight: 400;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
        }

        .active {
          font-weight: 800;
          color: #D81417;

          &::after {
            content: '';
            width: 51rem;
            height: 2rem;
            position: absolute;
            left: 50%;
            bottom: 0;
            margin-left: -25.5rem;
            background-color: #D81417;
          }

          &::before {
            content: '';
            width: 12rem;
            height: 8rem;
            background: url(/public/images/top-red.png);
            background-size: 100% 100%;
            position: absolute;
            right: -23rem;
            top: 50%;
            margin-top: -4rem;
          }
        }
      }
    }

    .secondary-title {
      width: 100%;
      height: 60rem;
      background: rgba(0, 0, 0, 0.03);
      font-weight: 400;
      font-size: 20rem;
      color: #333333;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 40rem;
      overflow: hidden;
      overflow-x: auto;

      &>div {
        width: 100%;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        font-family: PingFangSC-Regular;
        white-space: nowrap;

        span {
          cursor: pointer;
          margin: 0 20rem;
        }

        .active {
          font-weight: 800;
          color: #D81417;
        }
      }
    }
  }
}
</style>
